export const questions = [
  { question: "What State are you from?",
    responseChoices: "", 
    usersResponse: ""
  },
  {
    question: "Are you a survivor of domestic violence, sexual assault or both?",
    responseChoices: ["Sexual Assault", "Domestic Violence", "Both", "Neither"],
    usersResponse: ""
  },
  {
    question: "Did the person who sexually assaulted you have HIV/Aids, or are you unsure of the HIV/Aids status of the person who assaulted you?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you have an open case with the police / Do you have any interest in opening a police report?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "If the offender is in custody, or possibly expected to be in custody at some point: Would you like to get immediate updates when the offender's custody status changes?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you have or live with any children?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Were children present (anywhere in the household) during any of the incidents?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Were children ever recipients of physical, verbal or emotional abuse?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Did you ever experience or face threats of physical violence (personal injury, propert damage, etc) OR have a family member pass away from violence?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Have you ever filed a police report within 10 days of the incident?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Would you be interested in potentailly filing a police report? If so, this would make you eligble for up to $25,000 for medical expenses, psychological counseling, relocation aid and more.",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Are you under the age of 18?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Would you be interested in free and confidential psychological counseling and therapy resources?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Would you be interested in clinical/advocacy services?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you fear for your own physical safety (and/or your child's safety) from your abuser, and would you like to legally prevent your abuser from contacting/coming near you?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you currently have an open case with the police / do you have any interest in opening a police report?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Would you be interested in free legal counseling to evaluate your options and potentially get restitution?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },    
  {
    question: "Are you currently an undocumented immigrant?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Are you a survivor of human trafficking?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you want free legal assistance?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Would you be interested in having an attorney to sue the offender through a CIVIL case?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you identify as low income?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Are you currently experiencing homelessness?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you need immediate relocation support to escape any abusive/unsafe situations?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you identify as LGBTQ?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you have difficulty speaking or hearing?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  },
  {
    question: "Do you have any suicidal thoughts?",
    responseChoices: ["Yes", "No"],
    usersResponse: ""
  }
];